import { Component, OnInit, } from '@angular/core';
import { FormControl, FormGroup, Validators, } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from 'src/app/services/users.service';
@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  isError: boolean = false
  errorMassage = "זהו שדה חובה"
  errorMassage2 = "זהו שדה חובה"
  error: boolean
  hidePassword: boolean = true
  focus: boolean = false
  submited: Boolean
  nextRoute: string
  loading = false

  constructor(private router: Router, private userService: UsersService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(p => {
      this.nextRoute = p['nextRoute'] || ''
    })
  }

  loginForm: FormGroup = new FormGroup(
    {
      "name": new FormControl("", [Validators.required]),
      "password": new FormControl("", [Validators.required])
    }
  )

  hideOrShowPassword() {
    this.hidePassword = !this.hidePassword
  }

  submit() {
    if (!this.loading) {
      if (this.loginForm.valid) {
        this.loading = true
        this.userService.checkLoginDetails(this.loginForm.controls['name'].value, this.loginForm.controls['password'].value,
        )
          .subscribe(response => {
            console.log(response)
            localStorage.setItem('user', JSON.stringify(response))
            localStorage.setItem('lastLoginTime', JSON.stringify(new Date))
            this.userService.login(this.nextRoute)
            this.loading = false
          },
            error => {
              console.log(error)
              this.loading = false
              this.errorMassage2 = error.error
              this.error = true
              this.isError = true
            })
      }
      else
        this.submited = true
    }
  }

}